module.exports = __webpack_public_path__ + "static/media/faq-social.169d5e89.png";